import React from 'react'

function MoneyMarketFundBenefits() {
  return (
    <div>

Earn 8-10%* interest annually.<br/>
Easy sign up via MyBritam App available on Google Playstore and App Store and MyBritam Portal https://customerconnect.britam.com.<br/>
Easily track your savings and transact via the above digital channels.<br/>
Easy withdrawal straight to your M-Pesa or Bank account within 48 hours. <br/>
Also available via USSD *778#.<br/>




    </div>
  )
}

export default MoneyMarketFundBenefits